import { ROUTERS } from '@/constant';
import { searchParamsKey, useCreateListSubmit } from '@/hooks';
import { memo, useCallback, useMemo } from 'react';

import Button from '../common/button';
import { DefinePublicAssignmentModalButtonProps } from './define-public-assignment.type';

const DefinePublicAssignmentButton = (
	props: DefinePublicAssignmentModalButtonProps
) => {
	const {
		className,
		label = '공공형 등록',
		type = 'primary',

		hasFranchiseSelected,
		assignmentfranchiseid,
		publicFranchiseId,
		programId,
		franchiseId,
		franchiseName,
		districtId,
		districtName,
		startDate,
		endDate,
		startTime,
		endTime,
		relaxTime,
		requestApplicant,
		memo,
		applicantIds,
		callback,
		...restProps
	} = props;

	const toCreatePathName = useMemo(() => {
		const queryProps = {
			hasFranchiseSelected,
			assignmentfranchiseid,
			programId,
			franchiseId,
			franchiseName,
			districtId,
			districtName,
			startDate,
			endDate,
			startTime,
			endTime,
			relaxTime,
			publicFranchiseId,
			requestApplicant,
			memo,
			applicantIds,
		};
		return `${ROUTERS.DEFINE_PUBLIC_ASSIGNMENT}?${searchParamsKey}=${encodeURIComponent(JSON.stringify(queryProps))}`;
	}, [
		hasFranchiseSelected,
		assignmentfranchiseid,
		publicFranchiseId,
		programId,
		franchiseId,
		franchiseName,
		districtId,
		districtName,
		startDate,
		endDate,
		startTime,
		endTime,
		relaxTime,
		requestApplicant,
		memo,
		applicantIds,
	]);

	const { onCreateSubmit } = useCreateListSubmit({
		toCreatePathName,
	});

	const onClick = useCallback(() => {
		onCreateSubmit?.({
			callbackSuccess: callback,
		});
	}, [onCreateSubmit, callback]);

	if (props?.renderChildren) {
		return <div onClick={onClick}>{props.renderChildren}</div>;
	}

	return (
		<>
			<Button
				{...restProps}
				className={className}
				onClick={onClick}
				type={type}
			>
				{label}
			</Button>
		</>
	);
};

export default memo(DefinePublicAssignmentButton);
